import { OnyxDocument } from '../types'

export function getDocumentType(document: OnyxDocument): string {
  let type = 'External'
  if (typeof document?.link === 'string') {
    if (document?.link?.match(/community\.bitwarden\.com/)) {
      type = 'Community'
    } else if (document?.link?.match(/bitwarden\.com\/help/)) {
      type = 'Help'
    } else if (document?.link?.match(/bitwarden\.com\/blog/)) {
      type = 'Blog'
    } else if (
      document?.link?.match(/bitwarden\.com\/resources/) ||
      document?.link?.match(/bitwarden\.com\/.*\.pdf$/)
    ) {
      type = 'Resources'
    } else if (document?.link?.match(/bitwarden\.com/)) {
      type = 'Bitwarden'
    } else if (document?.link?.match(/github\.com/)) {
      type = 'GitHub'
    }
  }
  return type
}

export function shouldFilterDocumentLink(link: string): boolean {
  // Skip community child posts
  if (link?.match(/community\.bitwarden\.com/) && link?.match(/\/\d+\/\d+$/)) {
    return true
  }

  // Skip pdf documents
  if (link?.match(/\.pdf$/)) {
    return true
  }

  // Skip documents with url starting with /go
  if (link?.match(/^https:\/\/bitwarden\.com\/go/)) {
    return true
  }

  return false
}

export function dedupeDocuments(documents: OnyxDocument[]): OnyxDocument[] {
  return documents.reduce(
    (acc, next) => {
      if (shouldFilterDocumentLink(next.link || next.document_id)) {
        return acc
      }

      if (!acc.map.has(next.document_id)) {
        acc.map.set(next.document_id, true)
        acc.list.push(next)
      }
      return acc
    },
    { map: new Map(), list: [] as OnyxDocument[] }
  ).list
}
